// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__UcwOK","main":"Footer_main__14nje","names":"Footer_names__cakOz","commentMessage":"Footer_commentMessage__1NPRP","email":"Footer_email__2aKTD"};